module.exports = __webpack_public_path__ + "img/p3.ea2f742f.png";